/** @jsxImportSource @emotion/react */
import { PanelLeftIcon } from '@app/assets/icons/PanelLeftIcon'
import { Box, css } from '@mui/material'
import { SidebarAtom } from '@app/state/layoutAtom'
import { useAtom } from 'jotai'

interface SidebarTriggerProps {
  color?: string
  fullContainer?: boolean
  containerBackgroundColor?: string
  customCss?: React.CSSProperties
}

const SidebarTrigger = ({
  color = 'rgba(90, 90, 90, 0.8)',
  fullContainer = false,
  containerBackgroundColor = '',
  customCss = {},
}: SidebarTriggerProps) => {
  const [isOpen, setIsOpen] = useAtom(SidebarAtom)

  return (
    <Box
      style={customCss}
      css={SidebarTriggerStyleContainerStyle(fullContainer, containerBackgroundColor)}
    >
      <Box css={SidebarTriggerStyle} onClick={() => setIsOpen(!isOpen)}>
        <PanelLeftIcon
          color="white"
          style={{
            color: color,
            fontSize: 20,
          }}
        />
      </Box>
    </Box>
  )
}

export default SidebarTrigger

export const SidebarTriggerStyleContainerStyle = (
  fullContainer?: SidebarTriggerProps['fullContainer'],
  containerBackgroundColor?: SidebarTriggerProps['containerBackgroundColor'],
) => css`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${fullContainer ? '100%' : 'auto'};
  height: 60px;
  background-color: ${containerBackgroundColor};
  transition: background-color 0.2s ease;
`

export const SidebarTriggerStyle = css`
  width: 40px;
  height: 40px;
  border-radius: 100px;
  background: rgba(240, 240, 240, 0.1);
  margin-left: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: rgba(159, 159, 159, 0.3);
  }
`
